import {
    Box,
    IconButton,
    Typography,
    Button,
    Tooltip,
    Link,
    LinearProgress
} from '@mui/material';
import { calculatePercentageOfTotal } from '../../Template/template.constant.js';
import React, { useEffect, useMemo, useState } from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_SortingState,
} from 'material-react-table';
import { ConstantActions, TemplateActions } from '../../../../Services/_actions/index.js';
import { templateSummaryTableStateAtom, WhatsAppTempFormAtom } from '../../../../Services/_states/index.js';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { useNavigate, useParams } from 'react-router';
import { dateFormate, generateFilterKey } from '../../../../utils/helper.jsx';
import SweetAlert from '../../../Shared/Notification/index.jsx';
import SendTemplateForm from '../../Template/sendTemplateForm.jsx';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmBox from '../../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { useSnackBar } from '../../../FlowBuilder/Common/SnackBar/index.tsx';
import Pagination from '../../../FlowBuilder/Common/Pagination/index.tsx';
import SendTemplateModal from '../Template/SendTemplateModal.tsx';
import CommonTable from '../../../Shared/Tables/TableV1.tsx';
import { fetchTemplateSummarySelector } from '../../../../Services/_states/Template/templateSelector.ts';
import { globalpermissions } from '../../../../Services/Permission.js';
interface SummaryData {
    sent_date: string;
    total_users: number;
    sent_count: number;
    delivered_count: number;
    read_count: number;
    unique_button_count: number;
    button_count_1: number;
    button_count_2: number;
    button_count_3: number;
    template_id?: any;
}

const TemplatesTable: React.FC = () => {
    const [filter, setFilter] = useState('');
    const [summaryData, setSummaryData] = useState({});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
    const { templateName, botNumber } = useParams();
    const navigate = useNavigate();
    const actions = TemplateActions();
    const [whatsappTempFormData, setWhatsappTempFormData] = useRecoilState<any>(WhatsAppTempFormAtom);
    const [filters, setFilters] = useState({ template_id: '', search: '', page: 0, limit: 20, start_date: null, end_date: null, sort_by: 'sent_date', order: 'desc' });
    const [sorting, setSorting] = useState<MRT_SortingState>([]);
    const [openConfirmBox, setOpenConfirmBox] = useState(false);
    const { showSnackBar } = useSnackBar()

    const [isLoading, setIsLoading] = useState(false);
    const [showSendTemplate, setShowSendTemplate] = useState(false);
    const [showSummary, setShowSummary] = useState('summary');
    const [isValidFile, setIsValidFile] = useState(true);
    const [progressBar, setProgressBar] = useState(0);
    const [tempDataFile, setTempDataFile] = useState(null);
    const [graphData, setGraphData] = useState({});
    const [copySuccess, setCopySuccess] = useState(false);
    const [chartType, setChartType] = useState("bar");
    const constActions = ConstantActions();

    const [tableState, setTableState] = useRecoilState(templateSummaryTableStateAtom);
    const fetchedData = useRecoilValueLoadable(fetchTemplateSummarySelector);

    useEffect(() => {
        if (fetchedData.state === "hasValue" && !fetchedData.contents.fromCache) {
            const filterKey = generateFilterKey(tableState.filters);
            setTableState((prev) => ({
                ...prev,
                ...fetchedData.contents,
                cache: { ...prev.cache, [filterKey]: fetchedData.contents.data },
                totalCountCache: { ...prev.totalCountCache, [filterKey]: fetchedData.contents.totalCount },
            }));
        }
    }, [fetchedData, setTableState]);

    const handleChangePage = (event, newPage) => {
        console.log(newPage, "newPagenewPagenewPagenewPage")
        setTableState((prev) => ({
            ...prev,
            filters: { ...prev.filters, page: newPage },
        }));
    };
    const handleChangeRowsPerPage = (event) => {
        const value = parseInt(event.target.value, 10) || 10;
        setTableState((prev) => ({
            ...prev,
            filters: { ...prev.filters, limit: value },
        }));
    };


    // const getTemplateDateWiseSummary = async (filters) => {
    //     setIsLoading(true);
    //     setSummaryData({ ...summaryData, data: [] });
    //     filters['start_date'] = filters?.start_date ? dateFormate(filters.start_date, 'DD/MM/YYYY') : '';
    //     filters['end_date'] = filters?.end_date ? dateFormate(filters.end_date, 'DD/MM/YYYY') : '';
    //     let res = await actions.getTemplateDateWiseSummary(filters);
    //     setSummaryData(res);
    //     setIsLoading(false);
    // };
    const getTemplateData = async () => {
        try {
            if (whatsappTempFormData?.name === templateName && whatsappTempFormData?.bot_number === botNumber) {
                setTableState((prev) => ({
                    ...prev,
                    filters: { ...prev.filters, template_id: whatsappTempFormData?.md_id },
                }));
            } else {
                const res = await actions.getTemplateByNameAndBotNumber(templateName, botNumber);

                if (res?.status === 200 && res?.data) {
                    setWhatsappTempFormData(res.data);
                    setTableState((prev) => ({
                        ...prev,
                        filters: { ...prev.filters, template_id: res.data.md_id },
                    }));
                    // setFilters({ ...filters, template_id: res?.data?.md_id });
                    // getTemplateDateWiseSummary({ ...filters, template_id: res?.data?.md_id });
                } else {
                    console.error("Unexpected response status or missing data:", res);
                }
            }
        } catch (error) {
            console.error("Error fetching template data:", error);
        }
    };

    const downloadDateWiseSummary = (row) => {
        const url = `${process.env.REACT_APP_API_URL}/v0/ui/mca-bot/download-template-user-summary/?template_id=${row?.template_id}&date=${row?.sent_date}`;
        window.open(url, '_parent', 'noopener,noreferrer');
    };

    const onEditTemplate = () => {
        navigate(`/r/whatsapp/edit-template/${templateName}/${botNumber}`);
    };

    const handleDeleteTemplate = async () => {
        setOpenConfirmBox(true);
    };

    const handleConfirmDelete = async (confirmed) => {
        if (confirmed) {
            try {
                let res = await actions.deleteWhatsappTemplate(templateName, whatsappTempFormData);
                if (res?.status === 200) {
                    showSnackBar('Template Deleted Successfully', 'success');
                    navigate('/r/whatsapp/template-list');
                } else if (res?.status === 400) {
                    showSnackBar(res?.message || "Error deleting Template Details. Please try again.", 'error');
                } else {
                    showSnackBar('Error deleting Template Details. Please try again.', 'error');
                }
            } catch (error) {
                showSnackBar('Error deleting Template Details. Please try again.', 'error');
            }
        }
        setOpenConfirmBox(false)
    };

    useEffect(() => {
        getTemplateData();
    }, []);

    const columns = useMemo<MRT_ColumnDef<SummaryData>[] | any[]>(
        () => [
            {
                accessorKey: 'index',
                header: 'S.No.',
                Cell: ({ row, column, table }) => {
                    const rowIndex = row.index;
                    const page = tableState?.filters?.page;
                    return page * tableState?.filters?.limit + rowIndex + 1;

                    // const rowIndex = row.index;
                    // const page = table.getState().pagination.pageIndex;
                    // return (page * filters?.limit) + rowIndex + 1;
                },
                enableSorting: false,
                size: 10,
            },
            {
                accessorKey: 'sent_date',
                header: 'Sent Date',
                size: 20,

            },
            {
                accessorKey: 'total_users',
                header: 'Total User',
                size: 30,

            },
            {
                accessorKey: 'sent_count',
                header: (
                    <Tooltip title="Percentage of messages sent successfully out of total users">
                        <span>Sent (%)</span>
                    </Tooltip>
                ),
                size: 20,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.sent_count, row.original.total_users),
            },
            {
                accessorKey: 'delivered_count',
                header: (
                    <Tooltip title="Percentage of messages delivered successfully out of total users">
                        <span>Delivered (%)</span>
                    </Tooltip>
                ),
                size: 20,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.delivered_count, row.original.total_users),
            },
            {
                accessorKey: 'read_count',
                header: (
                    <Tooltip title="Percentage of messages read out of total users" >
                        <span>Read (%)</span>
                    </Tooltip>
                ),
                size: 20,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.read_count, row.original.total_users),
            },
            {
                accessorKey: 'unique_button_count',
                header: (
                    <Tooltip title="Percentage of unique button count">
                        <span>UBC (%)</span>
                    </Tooltip>
                ),
                size: 40,

                Cell: ({ row }) => calculatePercentageOfTotal(row.original.unique_button_count, row.original.total_users),
            },
            {
                accessorKey: 'button_count_1',
                header: (
                    <Tooltip title="Percentage of users who clicked Button 1 (POSITIVE)">
                        <span>B1 (%)</span>
                    </Tooltip>
                ),
                size: 20,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.button_count_1, row.original.total_users),
            },
            {
                accessorKey: 'button_count_2',
                header: (
                    <Tooltip title="Percentage of users who clicked Button 2 (NEUTRAL)">
                        <span>B2 (%)</span>
                    </Tooltip>
                ),
                size: 20,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.button_count_2, row.original.total_users),
            },
            {
                accessorKey: 'button_count_3',
                header: (
                    <Tooltip title="Percentage of users who clicked Button 3 (NEGATIVE)">
                        <span>B3 (%)</span>
                    </Tooltip>
                ),
                size: 40,
                Cell: ({ row }) => calculatePercentageOfTotal(row.original.button_count_3, row.original.total_users),
            },
            {
                accessorKey: 'template_id',
                header: 'View',
                enableSorting: false,
                size: 40,
                Cell: ({ row }) => (
                    <Link
                        onClick={() => navigate(`/r/whatsapp/template-users/${templateName}/${row?.original?.template_id}/${row?.original?.sent_date}`)}
                        color="primary"
                        style={{ cursor: 'pointer' }}
                    >
                        View
                    </Link>
                ),
            },
            {
                accessorKey: 'company_id',
                header: 'Download',
                size: 20,
                enableSorting: false,
                Cell: ({ row }) => (
                    <Link
                        onClick={() => downloadDateWiseSummary(row.original)}
                        color="primary"
                        style={{ cursor: 'pointer' }}
                    >
                        Download
                    </Link>
                ),
            },


        ],
        [tableState?.filters]
    );

    // useEffect(() => {
    //     if (sorting?.length > 0) {
    //         getTemplateDateWiseSummary({ ...filters, sort_by: sorting[0]?.id || "sent_date", order: sorting[0]?.desc ? "desc" : "asc" });
    //         setFilters((prevFilters) => ({
    //             ...prevFilters,
    //             sort_by: sorting[0]?.id || "sent_date",
    //             order: sorting[0]?.desc ? "desc" : "asc"
    //         }));
    //     }
    // }, [sorting]);

    useEffect(() => {
        if (sorting?.length > 0) {
            const { id, desc } = sorting[0];
            const updatedFilters = {
                ...tableState?.filters,
                sort_by: id || 'created_at',
                order: desc ? 'desc' : 'asc',
            };
            setTableState((prev) => (
                { ...prev, filters: { ...updatedFilters } }
            ))
        }
    }, [sorting]);

    // const downLoadSampleFile = async () => {
    //     window.location.href = `${process.env.REACT_APP_API_URL}/v0/ui/whatsapp/download-template-sample-sheet/?id=${whatsappTempFormData?.wa_Id}`
    // }
    // const onFileSelect = async (e) => {
    //     const selectedFile = e.target.files[0];
    //     setTempDataFile(selectedFile);
    // }

    // const onFileRemove = (e) => {
    //     setTempDataFile(null);
    //     setProgressBar(0);
    // }

    // const onUploadProgress = (progressEvent) => {
    //     const { loaded, total } = progressEvent;
    //     const percent = Math.floor((loaded * 100) / total);
    //     setProgressBar(percent);
    // };

    // const onFileUpload = async () => {
    //     let formData = new FormData();
    //     formData.append('file', tempDataFile);
    //     let res = await actions.uploadUserData(formData, whatsappTempFormData, onUploadProgress);
    //     if (res?.status === 200)
    //         SweetAlert('File Uploaded Successfully', 'success');
    //     else SweetAlert('Failed to Upload Data', 'error');
    // }

    // const handleChangePage = (event, newPage) => {
    //     getTemplateDateWiseSummary({ ...filters, page: newPage });
    //     setFilters({ ...filters, page: newPage });
    // };
    // const handleChangeRowsPerPage = (event) => {
    //     const value = parseInt(event.target.value, 10) || 10;
    //     getTemplateDateWiseSummary({
    //         ...filters,
    //         limit: value,
    //         page: 0
    //     });
    //     setFilters({
    //         ...filters,
    //         limit: value,
    //         page: 0
    //     });
    // };

    const handleSendButtonClick = () => {
        setShowSendTemplate(true); // Open the SendTemplateModal
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: { xs: 'wrap', sm: 'nowrap' }, gap: { xs: '8px', sm: 'auto' } }}>
                <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', lineHeight: { xs: '1.2', sm: 'auto' } }}>
                    {`Details of ${templateName}`}
                </Typography>
                <Box sx={{ display: 'flex', gap: '8px', pb: 0.5 }}>
                    {whatsappTempFormData?.status?.toLowerCase() === "approved" &&
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleSendButtonClick} // Open the modal on click
                        >
                            Send
                        </Button>
                    }

                    {constActions.userHasPermission([
                        globalpermissions?.templateDashboard?.editTemplates,
                    ]) && (
                            <Button variant="outlined" color="primary" size="small" onClick={() => {
                                onEditTemplate();
                            }}>
                                Edit
                            </Button>
                        )}
                    {constActions.userHasPermission([
                        globalpermissions?.templateDashboard?.deleteTemplates,
                    ]) && (
                            <Button variant="outlined" color="secondary" size="small" onClick={() => {
                                handleDeleteTemplate();
                            }}>
                                Delete
                            </Button>
                        )}
                    <ConfirmBox
                        open={openConfirmBox}
                        onClose={handleConfirmDelete}
                        options={{
                            title: `Delete ${templateName ? templateName : "Template"}`,
                            text: 'Are you sure you want to delete this Template?',
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'Cancel',
                            confirmButtonColor: 'error',
                            cancelButtonColor: 'default',
                        }}
                    />
                </Box>
                {showSendTemplate && (
                    <SendTemplateModal
                        open={showSendTemplate}
                        onClose={() => setShowSendTemplate(false)} // Close the modal on close
                    />
                )}
            </Box>
            <CommonTable
                columns={columns}
                data={tableState?.cache[generateFilterKey(tableState?.filters)] || []}
                // data={summaryData?.data || []}
                renderTopToolbar={false}
                muiTableBodyCellProps={{
                    sx: (theme) => ({
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
                        // textAlign: 'center',
                    }),
                }}
                muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 340px)', width: '100%' } }}
                muiTableHeadCellProps={{
                    sx: {
                        backgroundImage: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
                        color: 'white',
                        // textAlign: 'center',
                        fontWeight: '600',
                        fontSize: '14px',
                        fontFamily: 'system-ui',
                    },
                }}
                state={{
                    showColumnFilters: false,
                    sorting,
                }}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableHiding={false}
                enableStickyHeader={true}
                manualSorting={true}
                initialState={{
                    density: 'comfortable',
                }}
                enablePagination={false}
                manualPagination={false}
                onSortingChange={setSorting}
                // manualPagination={true}
                // paginationDisplayMode="pages"
                // pageCount={Math.ceil((summaryData?.total_count || 0) / (filters?.limit || 20))}
                // onPaginationChange={(paginationState) => {
                //     const { pageIndex, pageSize } =
                //         typeof paginationState === 'function'
                //             ? paginationState({ pageIndex: filters?.page || 0, pageSize: filters?.limit || 20 })
                //             : paginationState;

                //     if (pageIndex !== filters.page || pageSize !== filters.limit) {
                //         setFilters((prevFilters) => ({
                //             ...prevFilters,
                //             page: pageIndex,
                //             limit: pageSize,
                //         }));

                //         getTemplateDateWiseSummary({ ...filters, page: pageIndex, limit: pageSize });
                //     }
                // }}
                renderBottomToolbar={() => (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }}>
                        <Pagination
                            totalCount={tableState?.totalCountCache[generateFilterKey(tableState?.filters)] || 0}
                            // totalCount={summaryData?.total_count || 0}
                            // rowsPerPage={20}
                            rowsPerPage={tableState?.filters?.limit}
                            page={tableState?.filters?.page}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Box>
                )}

            />
        </Box>
    );
};

export default TemplatesTable;
